export interface ExceptionErrorResponse {
  code: string
  message: string
}

export class ExceptionError extends Error {
  status: number
  code: string

  constructor(error: ExceptionErrorResponse, status: number = 400) {
    super(error.message ?? 'Server error, please contact admin.')

    this.status = status
    this.code = error.code
  }
}
